import { render, staticRenderFns } from "./searchPanelNew.vue?vue&type=template&id=6ddbf61e&scoped=true&"
import script from "./searchPanelNew.vue?vue&type=script&lang=js&"
export * from "./searchPanelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddbf61e",
  null
  
)

export default component.exports